export default __webpack_public_path__ + "static/media/balls.d5e927bd.png";